import script from "./WCMultiColumnMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCMultiColumnMenu.vue?vue&type=script&setup=true&lang=ts"

import "./WCMultiColumnMenu.vue?vue&type=style&index=0&id=65ec5355&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65ec5355"]])

export default __exports__